var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCafeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_73683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.1224V12.8307L5.58333 13.7474H8.79167L10.625 12.3724L13.375 11.9141L16.5833 12.3724L16.125 15.5807L14.75 17.8724L12 19.2474H8.33333L5.125 17.8724L3.75 15.1224Z",
    fill: "#CFE8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.8312C4.51083 13.4197 5.65392 13.7635 6.95833 13.7479C8.26275 13.7635 9.40583 13.4197 10.1667 12.8312C10.9275 12.2427 12.0706 11.899 13.375 11.9146C14.6794 11.899 15.8225 12.2427 16.5833 12.8312",
    stroke: "#CFE8FC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33121 2.75C8.04109 2.95824 7.80603 3.23397 7.64632 3.55339C7.48662 3.8728 7.40707 4.2263 7.41455 4.58333C7.40707 4.94037 7.48662 5.29386 7.64632 5.61328C7.80603 5.93269 8.04109 6.20843 8.33121 6.41667",
    stroke: "#259AF9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0031 2.75C11.713 2.95824 11.4779 3.23397 11.3182 3.55339C11.1585 3.8728 11.0789 4.2263 11.0864 4.58333C11.0789 4.94037 11.1585 5.29386 11.3182 5.61328C11.4779 5.93269 11.713 6.20843 12.0031 6.41667",
    stroke: "#259AF9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.16406H16.5833V13.7474C16.5833 15.2061 16.0039 16.605 14.9724 17.6365C13.941 18.6679 12.542 19.2474 11.0833 19.2474H9.25C7.79131 19.2474 6.39236 18.6679 5.36091 17.6365C4.32946 16.605 3.75 15.2061 3.75 13.7474V9.16406Z",
    stroke: "#259AF9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 15.3352C16.7609 15.5231 17.2102 15.6076 17.6599 15.5812C18.1096 15.5548 18.5459 15.4184 18.9305 15.1839C19.3151 14.9494 19.6362 14.624 19.8656 14.2363C20.095 13.8486 20.2256 13.4106 20.2461 12.9606C20.2665 12.5106 20.176 12.0624 19.9827 11.6556C19.7893 11.2487 19.499 10.8956 19.1372 10.6272C18.7754 10.3589 18.3533 10.1835 17.9078 10.1165C17.4624 10.0495 17.0073 10.093 16.5826 10.2431",
    stroke: "#259AF9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_73683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCafeOn);
export default __webpack_public_path__ + "static/media/icon-cafe-on.8057927c6e754108b6bbe34809020e71.svg";
export { ForwardRef as ReactComponent };